import { makeStyles } from '@material-ui/core/styles'
import background from '../../assets/images/nice.png'

export const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    backgroundImage: `url(${background})`,
    backgroundPosition: 'center',
    justifyContent: 'center',
    alignItems: 'center',
  },

  card: {
    borderTop:'10px solid #035ea7',
    margin: '16px',
    width: '860px',
    boxShadow: '0px 3px 11px 0px rgba(0,0,0,0.75)',
    borderRadius: 10,
    backgroundPosition: 'center',
    display: 'flex',
    flexDirection: 'column',
    maxHeight: 'calc(100% - 32px)',
    overflowY: 'scroll',
    // backgroundColor: '#035ea7',

    [theme.breakpoints.down('700')]: {
      display: 'grid',
    },
    [theme.breakpoints.down('500')]: {
      width: '100%',
      margin: 0,
      maxHeight: 'none',
      height: 'inherit',
      borderRadius: 0,
      overflow: 'unset'
    },
  },

  text: {
    height: '100%',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    padding: '20px 70px',
    

    '& > div': {
      // backgroundColor: '#035ea7',
      // boxShadow: '0 0 50px #035ea7, 0 0 50px #035ea7, 0 0 50px #035ea7, 0 0 50px #035ea7',

      borderRadius: 60,
      padding: 16,
      '& h1': {
        margin: 0,
        paddingBottom: 32,
      },
      '& p': {
        color: 'black',
        margin: 0,
        padding: 16,
        textAlign: 'center',
      },
    },


    [theme.breakpoints.down('700')]: {
      padding: 16,
      height: 'auto',
      '& h1, & p': {
        padding: 0,
      },

    },
  },

  links: {
    display: 'flex',
    gap: 8,
    padding: 8,

    [theme.breakpoints.down('700')]: {
      flexDirection: 'column',
      height: 'auto',
    },

    '& a': {
      textDecoration: 'none',
      [theme.breakpoints.down('700')]: {
        height: '100%',
      },
      display: 'grid',
      placeItems: 'center',
      width: '100%',

      [theme.breakpoints.up('700')]: {
        '& > div': {
          borderTop:'5px solid transparent'
        },
        '&:hover > div': {
          transform: 'translateY(-8px)',
          borderTop:'5px solid #035ea7'
        }
      },
      
    },

    '& a > div': {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      flexDirection: 'column',
      backgroundColor: 'white',
      borderRadius: 8,
      height: 200,
      width: '100%',
      transition: 'transform ease .2s',

      '& > div': {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center'
      },

      [theme.breakpoints.down('700')]: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        height: 100,
        '& > div': {
          width: 'inherit',
          marginLeft: '20px'
        }
      },


    },

    '& > a:nth-child(1)': {
      '& *': {
        color: '#005d7f'
      },
      '& h3': {
        backgroundColor: '#005d7f44'
      },
      '&:hover': {
        boxShadow: '0 0 20px #005d7f44',
        zIndex: 1000
      }
    },
    '& > a:nth-child(2)': {
      '& *': {
        color: '#728f23'
      },
      '& h3': {
        backgroundColor: '#728f2344'
      },
      '&:hover': {
        boxShadow: '0 0 20px #728f2344',
        zIndex: 1000
      }
    },
    '& > a:nth-child(3)': {
      '& *': {
        color: '#5a5859'
      },
      '& h3': {
        backgroundColor: '#5a585944'
      },
      '&:hover': {
        boxShadow: '0 0 20px #5a585944',
        zIndex: 1000
      }
    },

    '& svg': {
      fontSize: '5rem',
    },

    '& h3, & h4': {
      margin: 0,
    },

    '& h3': {
      color: 'rgba(0,0,0,.6)',
      padding: '4px 12px',
      fontSize: 15,
      textTransform: 'uppercase',
      marginTop: 20,
      marginBottom: 8,
      borderRadius: 99,
      width: 100,
    },

    '& h4': {
      color: 'rgba(0,0,0,.6)',
      fontSize: 13,
    },
  }

}))